export default __webpack_public_path__ + "attention-icon.svg";